import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConstants } from '../../constants/api.constants';
import { ZohoTimeEntriesRoot } from '../../domain/zoho-books-domain';

export interface ZohoProject {
  project_id: string;
  project_name: string;
}

export interface ZohoTask {
  task_id: string;
  task_name: string;
}

@Injectable({
  providedIn: 'root',
})
export class ZohoBooksService {
  constructor(private httpClient: HttpClient) {}

  fetchTimeEntries(startDate: string, endDate: string, userEmail: string) {
    return this.httpClient.get<ZohoTimeEntriesRoot>(
      `${ApiConstants.ZOHO_TIME_ENTRIES_URL}?from_date=${startDate}&to_date=${endDate}&filter_by=Date.CustomDate`,
      { headers: { 'X-User-Email': userEmail } },
    );
  }

  checkAuthStatus(userEmail: string) {
    return this.httpClient.get<{ connected: boolean }>(
      `${ApiConstants.ZOHO_ROOT_API_URL}/auth/status?user_email=${encodeURIComponent(userEmail)}`,
    );
  }

  getAuthUrl() {
    return this.httpClient.get<{ url: string }>(`${ApiConstants.ZOHO_ROOT_API_URL}/auth/url`);
  }

  exchangeCode(code: string, userEmail: string) {
    return this.httpClient.post<{ success: boolean }>(`${ApiConstants.ZOHO_ROOT_API_URL}/auth/callback`, {
      code,
      user_email: userEmail,
    });
  }

  fetchZohoProjects(userEmail: string) {
    return this.httpClient.get<{ projects: ZohoProject[] }>(
      `${ApiConstants.ZOHO_ROOT_API_URL}/projects`,
      { headers: { 'X-User-Email': userEmail } },
    );
  }

  fetchZohoProjectTasks(zohoProjectId: string, userEmail: string) {
    return this.httpClient.get<{ task: ZohoTask[] }>(
      `${ApiConstants.ZOHO_ROOT_API_URL}/projects/${zohoProjectId}/tasks`,
      { headers: { 'X-User-Email': userEmail } },
    );
  }
}
